const CartIcon = ({ size = 22 }) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 24 24">
    <circle cx="9" cy="21" r="1" fill="#1976d2"/>
    <circle cx="20" cy="21" r="1" fill="#1976d2"/>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h7.72a2 2 0 0 0 2-1.61l1.6-8.39H6" stroke="#1976d2" strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);
export default CartIcon;